<template>
  <v-card-actions class="pa-1">
    <v-autocomplete
        label="Saved Queries"
        v-model="loadedQuery"
        :items="model === 'samples' ? [...userQueries, ...prebuildQueries] :userQueries"
        item-text="name"
        return-object
        clearable
    >
    </v-autocomplete>
    <v-tooltip bottom>
      <template v-slot:activator="{on}">
        <v-btn @click="submitQuery()" v-on="on" class="ml-3" outlined small><v-icon>undo</v-icon></v-btn>
      </template>
      <span>Re-run this query</span>
    </v-tooltip>
  </v-card-actions>
<!--<v-row>-->
<!--  <v-col cols="4">-->
<!--    <v-autocomplete-->
<!--        label="Saved Queries"-->
<!--        v-model="loadedQuery"-->
<!--        :items="model === 'samples' ? [...userQueries, ...prebuildQueries] :userQueries"-->
<!--        item-text="name"-->
<!--        return-object-->
<!--        clearable-->
<!--    >-->
<!--      <template v-slot:items></template>-->
<!--    </v-autocomplete>-->
<!--  </v-col>-->
<!--  <v-col cols="1">-->
<!--    <v-dialog v-model="show" max-width="900" scrollable>-->
<!--      <template v-slot:activator="{on}">-->
<!--        <slot name="activator" :on="on"></slot>-->
<!--&lt;!&ndash;        <v-btn v-on="on" color="primary">Big Query</v-btn>&ndash;&gt;-->
<!--      </template>-->
<!--      <v-card>-->
<!--        <v-card-actions>-->
<!--          <div class="title">Query Manager</div>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn @click="cancelDialog"><v-icon>close</v-icon></v-btn>-->
<!--        </v-card-actions>-->
<!--        <v-divider></v-divider>-->
<!--        <v-card-text class="pa-0">-->
<!--          <v-row no-gutters>-->
<!--            <v-col cols="3">-->
<!--                <div class="text-center title white&#45;&#45;text pt-2 pb-2">Queries</div>-->
<!--                <v-divider></v-divider>-->
<!--                <v-virtual-scroll :height="600" item-height="70" :items="(model === 'samples' ? [...userQueries, ...prebuildQueries] :userQueries)">-->
<!--                  <template v-slot:default="{item}">-->
<!--                    <v-tooltip bottom>-->
<!--                      <template v-slot:activator="{on}">-->
<!--                        <v-list-item v-on="on" :class="`${loadedQuery && loadedQuery.uid === item.uid ? 'v-list-item&#45;&#45;active' : ''} mt-1 mb-1 pl-2 pr-1`" @click="loadedQuery = item" link>-->
<!--                          <v-list-item-action class="mr-2 ml-0">-->
<!--                            <v-btn :disabled="typeof item.uid === 'number'" icon>-->
<!--                              <v-icon v-if="isDefaultQuery(item.uid)" color="yellow darken-2">mdi-star</v-icon>-->
<!--                              <v-icon v-else>mdi-star-outline</v-icon>-->
<!--                            </v-btn>-->
<!--                          </v-list-item-action>-->
<!--                          <v-list-item-content>-->
<!--                            <v-list-item-title>{{item.name}}</v-list-item-title>-->
<!--                            <v-list-item-subtitle>{{typeof item.uid !== 'number' ? 'Custom Query' : 'Built in Query'}}</v-list-item-subtitle>-->
<!--                          </v-list-item-content>-->
<!--                          <v-list-item-action v-if="typeof item.uid !== 'number'">-->
<!--                            <v-menu class="pa-0">-->
<!--                              <template v-slot:activator="{on}">-->
<!--                                <v-btn v-on="on" icon small><v-icon>mdi-dots-vertical</v-icon></v-btn>-->
<!--                              </template>-->
<!--                              <v-list class="ma-0 pa-0">-->
<!--                                <v-list-item>Set as default</v-list-item>-->
<!--                                <v-divider></v-divider>-->
<!--                                <Confirm>-->
<!--                                  <template v-slot:activator="{on}">-->
<!--                                    <v-list-item v-on="on">Delete</v-list-item>-->
<!--                                  </template>-->
<!--                                </Confirm>-->
<!--                              </v-list>-->
<!--                            </v-menu>-->
<!--                          </v-list-item-action>-->
<!--                        </v-list-item>-->
<!--                      </template>-->
<!--                      <span>{{item.name}}</span>-->
<!--                    </v-tooltip>-->
<!--                    <v-divider class="ma-0 pa-0"></v-divider>-->
<!--                  </template>-->
<!--                </v-virtual-scroll>-->
<!--&lt;!&ndash;                <v-list-item class="success" link>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-list-item-icon><v-icon>add</v-icon></v-list-item-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-list-item-title>Create New Query</v-list-item-title>&ndash;&gt;-->
<!--&lt;!&ndash;                </v-list-item>&ndash;&gt;-->
<!--            </v-col>-->
<!--            <v-col>-->
<!--&lt;!&ndash;              <QueryExplanation v-if="loadedQuery" :query="loadedQuery.query" :model="loadedQuery.model"></QueryExplanation>&ndash;&gt;-->
<!--&lt;!&ndash;              <v-card-actions class="pb-0 mb-0" v-if="saveQuery">&ndash;&gt;-->
<!--&lt;!&ndash;                <v-text-field v-model="name" label="Name Your Query" dense outlined></v-text-field>&ndash;&gt;-->
<!--&lt;!&ndash;              </v-card-actions>&ndash;&gt;-->
<!--              <v-divider v-if="saveQuery"></v-divider>-->
<!--              <v-card-text v-if="doneLoading" class="pt-2">-->
<!--                <template v-for="(value, key) in fillable">-->
<!--                  <QueryField-->
<!--                      v-if="key in form"-->
<!--                      v-model="form[key]"-->
<!--                      :key="key"-->
<!--                      :label="key.replace(/_/g, ' ').toUpperCase()"-->
<!--                      :field="value" :field_key="key"-->
<!--                      @toggle_field="toggleField($event)"-->
<!--                      @input:condition="form[key].condition = $event.condition"-->
<!--                      :selected="selectedFields.includes(key)"-->
<!--                  >-->
<!--                  </QueryField>-->
<!--                </template>-->
<!--                <v-divider></v-divider>-->
<!--                <div class="title">Relations</div>-->
<!--                <v-divider></v-divider>-->
<!--                <v-row no-gutters>-->
<!--                  <v-col cols="1"><v-checkbox v-model="selectedFields" value="has" dense></v-checkbox></v-col>-->
<!--                  <v-col>-->
<!--                    <v-select v-model="form.has" label="Has" :items="hasRelations" item-text="name" item-value="name" outlined dense>-->
<!--                    </v-select>-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--                <v-row no-gutters>-->
<!--                  <v-col cols="1"><v-checkbox v-model="selectedFields" value="where_has" dense></v-checkbox></v-col>-->
<!--                  <v-col>-->
<!--                    <v-select v-model="form.where_has.relation" label="Where Has" :items="hasRelations" item-text="name" item-value="name" outlined dense>-->
<!--                    </v-select>-->
<!--                    <template  v-if="whereHasFields.length > 0 && Object.keys(form.where_has.where).length > 0" >-->
<!--                      <v-row v-for="field in whereHasFields" :key="field.name" no-gutters>-->
<!--                        <QueryField-->
<!--                            v-model="form.where_has.where[field.name]"-->
<!--                            :key="field.name"-->
<!--                            :label="field.name.replace(/_/g, ' ').toUpperCase()"-->
<!--                            :field_key="field.name"-->
<!--                            :field="field.field"-->
<!--                            @toggle_field="toggleWhereHasField($event)"-->
<!--                            @input:condition="form.where_has.where[field.name].condition = $event.condition"-->
<!--                            :selected="selectedWhereHasFields.includes(field.name)"-->
<!--                        >-->
<!--                        </QueryField>-->
<!--                      </v-row>-->
<!--                    </template>-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--              </v-card-text>-->
<!--&lt;!&ndash;              <v-divider></v-divider>&ndash;&gt;-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--        </v-card-text>-->
<!--&lt;!&ndash;        <v-card-actions class="pb-1 pt-1">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="title">Big Query: {{this.model.toUpperCase()}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-spacer></v-spacer>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-checkbox v-model="saveQuery" label="Save Query" dense></v-checkbox>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-spacer></v-spacer>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-btn @click="show = false" icon> <v-icon>mdi-close</v-icon></v-btn>&ndash;&gt;-->
<!--&lt;!&ndash;        </v-card-actions>&ndash;&gt;-->
<!--&lt;!&ndash;        <v-divider></v-divider>&ndash;&gt;-->

<!--&lt;!&ndash;        <v-card-actions>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-btn @click="show = false" text>close</v-btn>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-spacer></v-spacer>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-checkbox v-if="saveQuery" v-model="setAsDefaultQuery" label="Set as default for this page" dense></v-checkbox>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-spacer></v-spacer>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-btn @click="submitQuery()" color="success">{{saveQuery ?  'Save & run' : ''}}Query</v-btn>&ndash;&gt;-->
<!--&lt;!&ndash;        </v-card-actions>&ndash;&gt;-->
<!--        <v-divider></v-divider>-->
<!--        <v-card-actions>-->
<!--          <v-btn @click="cancelDialog">Cancel</v-btn>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn @click="submitQuery(loadedQuery)" color="success">Run Query</v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->
<!--  </v-col>-->
<!--</v-row>-->
</template>

<script>
export default
{
  name: "MasterQuery",
  components: {
    QueryField: () => import("@/components/QueryBuilder/QueryField"),
    QueryExplanation: () => import("@/components/QueryBuilder/QueryExplanation")
  },
  props:{
    model: {
      default: 'samples',
      type: String
    },
    with: {
      required: false,
      default: null
    }
  },
  data: () => ({
    show: false,
    querying: false,
    doneLoading: false,
    saveQuery: false,
    setAsDefaultQuery: false,
    loadedQuery: null,
    userQueryListener: null,
    userQueries: [],
    name: null,
    form: {
      has: null,
      where_has: {
        relation: null,
        where: {}
      },
    },
    selectedFields: [],
    selectedWhereHasFields: [],
    options:{
      save: false,
      name: null,
    },
    prebuildQueries: [
      {
        uid: 1,
        model: 'samples',
        name: "All Samples",
        query: {
          has: 'sampleTests',
          with: 'sampleTests'
        }
      },
      {
        uid: 5,
        model: "samples",
        name: "Active Samples",
        query: {
          where: [{
            key: "is_released",
            value: false,
          }],
          with:"sampleTests,sampleNotes,sampleFlags",
          not_null: 'order_id',
        }
      },
      {
        uid: 4,
        model: 'samples',
        name: "Released",
        query: {
          where:[{
            key: 'is_released',
            value: true
          }]
        }
      },
      {
        uid: 5,
        model: 'samples',
        name: "Qa approved",
        query: {
          where:[
            {
              key: "is_released",
              value: false,
            },
            {
              key: 'qa_approved',
              value: true
            }
          ]
        }
      },
      {
        uid: 2,
        model: 'samples',
        name: "Needs QA",
        query: {
          where:[
            {
              key: "qa_approved",
              value: false,
            },
            {
              key: "is_released",
              value: false,
            },
            {
              key: "customer_id",
              condition: "!=",
              value: 90
            }
          ],
          where_has:{
            relation: 'sampleTests',
            has: "sampleTestAnalytes",
            where:[
              {
                key: "active",
                value: true,
              },
              {
                key: "complete",
                value: false,
              }
            ],
          }
        }
      },
      {
        uid: 3,
        model: 'samples',
        name: "Retests, need QA",
        query: {
          where:[{
            key: "qa_approved",
            value: false,
          }],
          where_has:{
            relation: 'sampleTests',
            has: "sampleTestAnalytes",
            where:[
              {
                key: "complete",
                value: false,
              },
              {
                key: "retest",
                value: true,
              },
              {
                key: "active",
                value: true,
              },
            ]
          }
        }
      },
    ]
  }),
  computed:{
    dbModel(){return this.$store.$db().model(this.model)},
    fields(){
      return this.dbModel.getFields();
    },
    fillable(){
      let fillableObject = {};
      for(const [key, value] of Object.entries(this.fields)){
        if(!this.fields[key].related && !this.fields[key].parent && !this.dbModel.ignoredLogFields().includes(key) && (key.includes("type_uuid") || !key.includes("_uuid"))){
          fillableObject[key] = value;
        }
      }
      return fillableObject
    },
    relations(){
      let fillableObject = {};
      for(const [key, value] of Object.entries(this.fields)){
        if(this.fields[key].related || this.fields[key].parent){
          fillableObject[key] = value;
        }
      }
      return fillableObject
    },
    hasRelations(){
      let relations = [];
      for(const [key, value] of Object.entries(this.relations)){
        if(key !== 'customer'){
          let keySplit = key.split("_");
          keySplit.forEach((item, index) => {
            if(index > 0){
              keySplit[index] = this.capitalizeFirstLetter(keySplit[index])
            }
          })
          let keyName = keySplit.join('');
          relations.push({
            name: keyName,
            model: value.parent ? value.parent : value.related,
          })
          let subFields = value.parent ? value.parent.getFields() : value.related.getFields();
          for(const [subkey, subvalue] of Object.entries(subFields)){
            if((subFields[subkey].related && subFields[subkey].related.entity !== this.model) || (subFields[subkey].parent && subFields[subkey].parent.entity !== this.model))
            {
              let subKeySplit = subkey.split("_");
              subKeySplit.forEach((item, index) => {
                if(index > 0){
                  subKeySplit[index] = this.capitalizeFirstLetter(subKeySplit[index])
                }
              })
              relations.push({
                name:`${keyName}.${subKeySplit.join('')}`,
                model: subvalue.parent ? subvalue.parent : subvalue.related,
              })
            }
          }
        }

      }
      return relations;
    },
    whereHasFields(){
      if(this.selectedFields.includes('where_has') && this.form.where_has.relation){
        let model = this.hasRelations.find(relation => relation.name === this.form.where_has.relation).model;
        let fields = model.getFields();
        let fillables = [];
        for(const [key, value] of Object.entries(fields)){
          if(!fields[key].related && !fields[key].parent && !value.model.ignoredLogFields().includes(key) && (key.includes("type_uuid") || !key.includes("_uuid"))){
            fillables.push({
              name: key,
              field: value
            });
          }
        }
        return fillables
      }
      return []
    }
  },
  watch: {
    whereHasFields(v){
      if(v && v.length > 0){
        let fillableObject = {};
        v.forEach(value => {
          if(value.field.constructor.name === "Boolean"){
            fillableObject[value.name] = null;
          }else{
            fillableObject[value.name] = {
              condition: "=",
              value: null,
            }
          }
        })
        this.form.where_has.where = fillableObject
      }
    },
    show(v){
      if(v && this.loadedQuery){
        this.saveQuery = !!this.loadedQuery.uid;
        this.name = !!this.loadedQuery.uid ? this.loadedQuery.name : null;
        this.loadQuery(this.loadedQuery)
      }
    },
    loadedQuery(v){
      if(v){
        this.loadQuery(this.loadedQuery)
      }
      if(v && !this.show){
        this.submitQuery(v);
      }
    },
    saveQuery(v){
      if(!v){
        this.selectedFields = [];
        this.selectedWhereHasFields = [];
        this.$nextTick(() => {
          this.loadedQuery = null;
          this.name = null;
        })
      }
    }
  },
  mounted(){
    this.loadUserQueries();
    for(const [key, value] of Object.entries(this.fillable)){
        if(value.constructor.name === "Boolean"){
          this.form[key] = null;
        }else{
          this.form[key] = {
            condition: "=",
            value: null,
          };
        }
    }
    this.loadPrebuilt()
    this.doneLoading = true;
  },
  beforeDestroy() {
    if(!this.userQueryListener){
      this.userQueryListener();
    }
  },
  methods: {
    loadUserQueries(){
      this.userQueries = []
      if(this.userQueryListener) this.userQueryListener();
      let user = this.$store.state.user.ref ? this.$store.state.user.ref : this.$firestore.collection('users').doc(this.$store.getters.id);
      this.userQueryListener = user.collection('queries').where('model', '==', this.model).onSnapshot((snap) => {
        snap.docChanges().forEach(change => {
          let data = change.doc.data();
          let storedQuery = {
            ref: change.doc.ref,
            uid: change.doc.id,
            ...data
          };
          if(change.type === "added"){
              this.userQueries.push(storedQuery)
          }else if(change.type === "modified"){
            let found = this.userQueries.findIndex((item) => item.uid === change.doc.id);
            this.$set(this.userQueries, found, storedQuery)
          }else if(change.type === "deleted"){
            let found = this.userQueries.findIndex((item) => item.uid === change.doc.id);
            this.userQueries.splice(found, 1);
          }
          if(this.$store.state.user.default_queries[this.$router.currentRoute.name] && this.$store.state.user.default_queries[this.$router.currentRoute.name] === change.doc.id){
            this.$set(this, 'loadedQuery', storedQuery);
          }
        })
      })
    },
    capitalizeFirstLetter(text){
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    toggleField(field){
      if(this.selectedFields.includes(field)){
        let indexOfField = this.selectedFields.indexOf(field);
        this.selectedFields.splice(indexOfField, 1);
      }else{
        this.selectedFields.push(field)
      }
    },
    toggleWhereHasField(field){
      if(this.selectedWhereHasFields.includes(field)){
        let indexOfField = this.selectedWhereHasFields.indexOf(field);
        this.selectedWhereHasFields.splice(indexOfField, 1);
      }else{
        this.selectedWhereHasFields.push(field)
      }
    },
    async submitQuery(savedQuery = false){
      if(this.querying) return;
      this.querying= true;
      let query = savedQuery ? savedQuery : this.buildQuery();
      if(!this.isValidQuery(query.query)){
        this.$store.dispatch("showError", 'Invalid query, please make sure you have checked the checkboxes next to your desired fields and that the fields are not empty.');
        this.querying = false;
        return;
      }
      if(!savedQuery && this.saveQuery){
        if(!this.name){
          this.$store.dispatch("showError", "Please name your query.");
          return;
        }
       if(this.loadedQuery){
         await this.loadedQuery.ref.update({
           name: this.name,
           ...query
         })
         if(this.setAsDefaultQuery){
           this.$store.state.user.ref.update({
           default_queries: {
             ...this.$store.state.user.default_queries,
             [this.$router.currentRoute.name]: this.loadedQuery.uid
           }
         })
         }
         this.$store.dispatch("showSuccess", "Updated query")
       }else{
         let savedUserQuery = await this.$firestore.collection('users').doc(this.$store.getters.id).collection('queries').add({
           name: this.name,
           ...query
         })
         if(this.setAsDefaultQuery){
           this.$store.state.user.ref.update({
           default_queries: {
             ...this.$store.state.user.default_queries,
             [this.$router.currentRoute.name]: savedUserQuery.id
           }
         })
         }
       }
         // save built query
        if(this.setAsDefaultQuery){
          let user = await this.$store.state.user.ref.get();
          let data = user.data();
          if(data.default_queries){
            this.$store.state.user.default_queries = data.default_queries;
          }
        }
      }
      // this.buildOrmQuery(query)
      const ormQuery = this.buildOrmQuery(query);
      this.$emit('query', ormQuery);
      this.querying = false;
      this.show = false;
    },
    buildQuery(){
      let fbObject = {
        model: this.model,
        query: {
        }
      };
      for(const i in this.selectedFields){
        if(this.selectedFields[i] === "where_has"){
          if(!fbObject.query.where_has) fbObject.query.where_has = {relation: this.form.where_has.relation, where: []}
          for(const j in this.selectedWhereHasFields){
            if(typeof this.form.where_has.where[this.selectedWhereHasFields[j]] === 'object'){
              fbObject.query.where_has.where.push({
                key: this.selectedWhereHasFields[j],
                condition: this.form.where_has.where[this.selectedWhereHasFields[j]].condition,
                value: this.form.where_has.where[this.selectedWhereHasFields[j]].value,
              })
            }else{
              fbObject.query.where_has.where.push({
                key: this.selectedWhereHasFields[j],
                value: this.form.where_has.where[this.selectedWhereHasFields[j]],
              })
            }
          }
        }else if(this.selectedFields[i] === "has"){
          fbObject.query.has = this.form.has;
        }else{
          if(!fbObject.query.where) fbObject.query.where = [];
          if(typeof this.form[this.selectedFields[i]] === 'object'){
            fbObject.query.where.push({
              key: this.selectedFields[i],
              condition: this.form[this.selectedFields[i]].condition,
              value: this.form[this.selectedFields[i]].value,
            })
          }else{
            fbObject.query.where.push({
              key: this.selectedFields[i],
              value: this.form[this.selectedFields[i]],
            })
          }
        }
      }
      if(fbObject.query.where_has && fbObject.query.has){
        fbObject.query.with = fbObject.query.where_has.relation.includes(fbObject.query.has) ? fbObject.query.has : fbObject.query.has + ',' + fbObject.query.where_has.relation;
      }else if(fbObject.query.has){
        fbObject.query.with = fbObject.query.has;
      }else if(fbObject.query.where_has && fbObject.query.where_has.relation){
        fbObject.query.with = fbObject.query.where_has.relation;
      }
      return fbObject
    },
    buildOrmQuery(query){
      let model = this.$store.$db().model(query.model);
      let queryModel = model.query();
      const relationTranslate = /([A-Z])/g
      if(query.query.where){
        for(const i in query.query.where){
          const where = query.query.where[i];
          if(!where.condition) {
            queryModel = queryModel.where(where.key, where.value)
          }else if(where.condition === "LIKE"){
            queryModel = queryModel.where(where.key, (value) => value === where.value || String(value).includes(String(where.value).replace(/%/g, '')))
          }else{
            queryModel = queryModel.where(where.key, (value) =>{
              switch(where.condition){
                case "=":
                  return value === where.value
                case "!=":
                  return value !== where.value
                case ">":
                  return Number(value) > Number(where.value)
                case ">=":
                  return Number(value) >= Number(where.value)
                case "<":
                  return Number(value) < Number(where.value)
                case "<=":
                  return Number(value) <= Number(where.value)
              }
            })
          }
        }
      }
      if(query.query.where_has){
        const convertWhereHas = query.query.where_has.relation.replace(relationTranslate, '_$1').toLowerCase();
        if(convertWhereHas.includes('.')){
          let splitWhereHas = convertWhereHas.split('.')
          queryModel = queryModel.whereHas(splitWhereHas[0], (subQuery) => {
            subQuery.whereHas(splitWhereHas[1], (sq) => {
              for(const i in query.query.where_has.where){
                const where = query.query.where_has.where[i];
                if(!where.condition) {
                  sq.where(where.key, where.value);
                }else if(where.condition === "LIKE"){
                  sq.where(where.key, (value) => value === where.value || String(value).includes(String(where.value).replace(/%/g, '')))
                }else{
                  sq.where(where.key, (value) => {
                    switch(where.condition){
                      case "=":
                        return value === where.value
                      case "!=":
                        return value !== where.value
                      case ">":
                        return Number(value) > Number(where.value)
                      case ">=":
                        return Number(value) >= Number(where.value)
                      case "<":
                        return Number(value) < Number(where.value)
                      case "<=":
                        return Number(value) <= Number(where.value)
                    }
                  })
                }
              }
            })
          })
        }else{
          queryModel = queryModel.whereHas(convertWhereHas, (subQuery) => {
            for(const i in query.query.where_has.where){
              const where = query.query.where_has.where[i];
              if(!where.condition) {
                subQuery.where(where.key, where.value);
              }else if(where.condition === "LIKE"){
                subQuery.where(where.key, (value) => value === where.value || String(value).includes(String(where.value).replace(/%/g, '')))
              }else{
                subQuery.where(where.key, (value) => {
                  switch(where.condition){
                    case "=":
                      return value === where.value
                    case "!=":
                      return value !== where.value
                    case ">":
                      return Number(value) > Number(where.value)
                    case ">=":
                      return Number(value) >= Number(where.value)
                    case "<":
                      return Number(value) < Number(where.value)
                    case "<=":
                      return Number(value) <= Number(where.value)
                  }
                })
              }
            }
          })
        }
      }
      if(query.query.has){
        const convertHas = query.query.has.replace(relationTranslate, '_$1').toLowerCase();
        if(convertHas.includes(".")){
          let split = convertHas.split('.');
          queryModel = queryModel.whereHas(split[0], (subQuery) => {
            subQuery.has(split[1])
          })
        }else{
          queryModel = queryModel.has(convertHas)
        }
      }
      return {model: model, query: queryModel, raw: query}
    },
    isValidQuery(query){
      let validationArray = [];
      if(query.where){
        if(!query.where.length) validationArray.push(false);
        validationArray.push(query.where.every(v => v.value !== '' && v.value != null && typeof v.value !== 'object'));
      }
      if(query.where_has){
        if(!query.where_has.relation) validationArray.push(false);
        if(!query.where_has.where.length) validationArray.push(false)
        validationArray.push(query.where_has.where.every(v => v.value !== '' && v.value != null && typeof v.value !== 'object'))
      }
      if(!query.where && !query.where_has && !query.has) validationArray.push(false);
      return validationArray.every(v => v === true);
    },
    loadQuery(savedQuery){
      if(savedQuery.model === this.model){
        if(savedQuery.name && savedQuery.uid) this.name = savedQuery.name;
        let query = savedQuery.query
        if(query.where){
          this.selectedFields = [];
          query.where.forEach(item => {
            this.selectedFields.push(item.key);
            if(item.condition){
              // this.$set(this.form.where, item.key, {condition: item.condition, value: item.value})
              this.form[item.key] = {condition: item.condition, value: item.value};
            }else{
              // this.$set(this.form.where, item.key,  item.value)
              this.form[item.key] = item.value;
            }
          })
        }
        if(query.where_has){
          this.selectedWhereHasFields = []
          this.selectedFields.push('where_has')
          this.form.where_has.relation = query.where_has.relation;
          this.$nextTick(() => {
            query.where_has.where.forEach(item => {
              this.selectedWhereHasFields.push(item.key);
              if(item.condition){
                this.form.where_has.where[item.key] = {condition: item.condition, value: item.value};
              }else{
                this.form.where_has.where[item.key] = item.value;
              }
            })
          })
        }
        if(query.has) {
          this.selectedFields.push('has')
          this.form.has = query.has;
        }
      }
    },
    cancelDialog(){
      this.loadUserQueries();
      this.loadPrebuilt(true);
      this.show = false;
    },
    isDefaultQuery(uid){
      if(this.$store.state.user.default_queries[this.$router.currentRoute.name]){
        const userQuery = this.$store.state.user.default_queries[this.$router.currentRoute.name];
        return userQuery === uid;
      }else{
        if(this.$router.currentRoute.name === "Qa" && uid === 2){
          return true
        }
        if(this.$router.currentRoute.name === 'Tracking' && uid === 1){
          return true
        }
      }
      return false;
    },
    loadPrebuilt(force = false){
      console.log('running')
      if(!this.loadedQuery || force){
        console.log('running2')
        if(this.$router.currentRoute.name === 'Qa' && !this.$store.state.user.default_queries[this.$router.currentRoute.name]){
          this.loadedQuery = this.prebuildQueries.find(item => item.name === "Needs QA")
        }else if(this.$router.currentRoute.name === 'Tracking' && !this.$store.state.user.default_queries[this.$router.currentRoute.name]){
          this.loadedQuery = this.prebuildQueries.find(item => item.name === "Active Samples")
        }else if(!this.$store.state.user.default_queries[this.$router.currentRoute.name]){
          this.loadedQuery = this.prebuildQueries.find(item => item.name === "All Samples")
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
